import { Link } from "gatsby"
import { hyphenateHTMLSync } from "hyphen/fi"
import React from "react"

import styles from "./SideList.module.scss"

const SideList = ({ heading, links }) => {
  const linkList = links
    ?.map((item, index) => {
      return item.link ? (
        <li key={index + item.link.title}>
          {item.link.target === "_blank" && (
            <a href={item.link.url} target="_blank" rel="noopener noreferrer">
              {item.link.title ? hyphenateHTMLSync(item.link.title) : ""}
            </a>
          )}
          {item.link.target !== "_blank" && (
            <Link to={item.link.url}>
              {item.link.title ? hyphenateHTMLSync(item.link.title) : ""}
            </Link>
          )}
        </li>
      ) : null
    })
    .filter(Boolean)

  return (
    <section className={`${styles.element} make-full-width-on-mobile`}>
      <div className={styles.container}>
        <h2>{heading}</h2>
        {linkList?.length > 0 && <ol className={styles.list}>{linkList}</ol>}
      </div>
    </section>
  )
}

export default SideList
